<template>
  <svg version="1.1" :width="diameter" :height="diameter" :viewBox="`0 0 ${diameter} ${diameter}`">
    <circle :cx="radius" :cy="radius" :r="radius - strokeWidth / 2" fill="#fff" stroke="#979797" stroke-width="1"></circle>
    <path :d="`M ${pathDMValue} A ${pathDAValue}`" fill="none" stroke="#ff9662" :stroke-width="strokeWidth"></path>
  </svg>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  maxTime: Number,
  currentTime: Number,
  diameter: Number,
  isDays: Boolean,
});

const strokeWidth = ref(3);

const radius = computed(() => {
  return props.diameter / 2;
});

const angle = computed(() => {
  const getAngle = 360 * (props.currentTime / props.maxTime);
  if (props.isDays) {
    if (props.currentTime === props.maxTime) {
      return 359.9; // days needs to show full circle in this case instead of empty
    } else {
      return getAngle;
    }
  } else {
    return getAngle;
  }
});

const pathDMValue = computed(() => {
  return `${radius.value} ${strokeWidth.value / 2}`;
});

const pathDAValue = computed(() => {
  const radiusAdjusted = radius.value - strokeWidth.value / 2;
  const x = (radiusAdjusted * Math.cos((angle.value - 90) * Math.PI / 180)) + radius.value;
  const y = (radiusAdjusted * Math.sin((angle.value - 90) * Math.PI / 180)) + radius.value;
  let largeArcFlag = 0;

  if (angle.value > 180) largeArcFlag = 1;

  return `${radiusAdjusted} ${radiusAdjusted} 0 ${largeArcFlag} 1 ${x} ${y}`;
});
</script>
